import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { SubCategoryItems } from '@features/trend-research/components/details/components/Filters';
import useQueryString from '@features/trend-research/hooks/useQueryString';
import { formatFabricName } from '@features/trend-research/utils/utils';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { findTrendResearchGraphics } from '@services/trendResearch';

const Graphics = ({ graphicsType, onSelectionChange }) => {
	const dispatch = useDispatch();
	const location = useLocation();

	const [queryStringForApi, setQueryStringForApi] = useState('');
	const [selectedItems, setSelectedItems] = useState([]);
	const [graphics, setGraphics] = useState({});

	const queryString = useQueryString();
	const { source } = location?.state || {};

	const handleSelectionChange = (color) => {
		onSelectionChange(color);
	};

	useEffect(() => {
		if (queryString) {
			const searchParams = new URLSearchParams(queryString);
			searchParams.append('graphicsType', graphicsType);
			const updatedQueryString = `?${searchParams.toString()}`;
			setQueryStringForApi(updatedQueryString);
		}
	}, [queryString, graphicsType]);

	const fetchColorGraphicsSubCategory = async () => {
		try {
			dispatch(openLoader());
			const response = await findTrendResearchGraphics(source.toUpperCase(), queryStringForApi);
			setGraphics(response);

			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};
	useEffect(() => {
		if (queryStringForApi !== '') {
			fetchColorGraphicsSubCategory();
		}
	}, [queryStringForApi]);

	useEffect(() => {
		if (location?.state && location?.state?.selectedItem) {
			setSelectedItems(formatFabricName(location?.state?.selectedItem?.graphicsName));
		}
	}, [location.state, graphicsType]);

	return (
		<SubCategoryItems
			items={graphics}
			selectedItems={selectedItems}
			onSelectionChange={handleSelectionChange}
			multiple
			showAll
			isSlideShow
			scrollTop={300}
			graphicsType={graphicsType}
		/>
	);
};

export default Graphics;
